import { getMarket, getPlatform } from '@/domains/core/settings/utils';
import { useAuth } from '@/domains/customerManagement/auth/hooks/useAuth';
import { useLoyaltyHvcUserLevelQuery } from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyLevelLabel/generated/loyaltyHvcUserLevel.query.generated';
import { LoyaltyLevelLabel } from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyLevelLabel/LoyaltyLevelLabel';
import type { Channel, Market, Platform } from '@/generated/graphql/types';

export const LoyaltyLevelLabelWrapper = () => {
  const { isAuthenticated } = useAuth();

  const [{ data }] = useLoyaltyHvcUserLevelQuery({
    requestPolicy: 'cache-and-network',
    variables: {
      platform: getPlatform().toUpperCase() as Platform,
      market: getMarket().toUpperCase() as Market,
      channel: 'WEB' as Channel,
    },
    pause: !isAuthenticated,
  });

  const level = data?.loyaltyHVCLevelStatus?.level.name;

  if (!level) return null;

  return <LoyaltyLevelLabel levelToDisplay={level} />;
};

LoyaltyLevelLabelWrapper.displayName = 'LoyaltyLevelLabelWrapper';
